import GeoFenced from "./GeoFencedV2";

export default GeoFenced;
